/* v8 ignore start */
import {TIntBoolean} from "@/lib/lottie/helpers/intBoolean";
import {LottieVisualObjectModel} from "@/lib/lottie/helpers/lottieVisualObjectModel";
import {LottieLayerType} from "@/lib/lottie/layers/lottieLayerType";

export class LottieLayerModel<
  T extends LottieLayerModel.IJson = LottieLayerModel.IJson,
> extends LottieVisualObjectModel<T> {
  public get inPoint(): number {
    return this.json.ip;
  }

  public get outPoint(): number {
    return this.json.op;
  }

  public get startTime(): number {
    return this.json.st;
  }

  public get totalFrames(): number {
    return this.outPoint - this.inPoint;
  }

  public adjustTimingBy(factor: number) {
    return this.update({
      ip: this.inPoint * factor,
      st: this.startTime * factor,
      op: this.outPoint * factor,
    } as Partial<T>);
  }

  public offsetTimingBy(offset: number) {
    return this.update({
      ip: this.inPoint + offset,
      st: this.startTime + offset,
      op: this.outPoint + offset,
    } as Partial<T>);
  }
}

export namespace LottieLayerModel {
  export interface IJson extends LottieVisualObjectModel.IJson {
    /**
     * Whether the layer is three-dimensional
     * @default 0
     */
    ddd?: TIntBoolean;

    /**
     * Whether the layer is hidden
     */
    hd?: boolean;

    /**
     * Layer Type
     */
    ty: LottieLayerType;

    /**
     * Index that can be used for parenting and referenced in expressions
     */
    ind?: number;

    /**
     * Must be the `ind` property of another layer
     */
    parent?: number;

    /**
     * Time Stretch
     * @default 1
     */
    sr?: number;

    /**
     * Frame when the layer becomes visible
     */
    ip: number;

    /**
     * Frame when the layer becomes invisible
     */
    op: number;

    /**
     * Start Time
     * @default 0
     */
    st: number;
  }
}
/* v8 ignore stop */
